<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Vessel Class" subTitle="Forms" />

    <ListVesselClass />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListVesselClass from "@/components/Pages/Master/VesselClass/ListVesselClass.vue";

export default defineComponent({
  name: "ListVesselClassPage",
  components: {
    PageTitle,
    ListVesselClass,
  },
});
</script>
